import { render, staticRenderFns } from "./userviprecordlist.vue?vue&type=template&id=36134a1c&scoped=true"
import script from "./userviprecordlist.vue?vue&type=script&lang=js"
export * from "./userviprecordlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36134a1c",
  null
  
)

export default component.exports